// extracted by mini-css-extract-plugin
export default {"itemWrapper":"itemWrapper__pZWAU","menuItem":"menuItem__fuuR6","active":"active__VjVjh","prevArrow":"prevArrow__B2FaK","nextArrow":"nextArrow__UXcjT","hide":"hide__oyv7j"};